export interface FeaturedProduct {
  id: string;
  name: string;
  brand: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  tag?: string;
}

export const featuredProducts: FeaturedProduct[] = [
  {
    id: 'nike-dunk',
    name: 'Nike Dunk Low Retro Panda',
    brand: 'Nike',
    image: 'https://readdy.ai/api/search-image?query=Black%20and%20white%20Nike%20Dunk%20Low%20Panda%20edition%20sneaker%20isolated%20on%20warm%20beige%20surface%2C%20side%20profile%20view%2C%20editorial%20product%20photography%20with%20dramatic%20soft%20side%20lighting%20creating%20depth%2C%20subtle%20reflection%20on%20surface%2C%20high%20contrast%20monochrome%20tones%2C%20premium%20sneaker%20presentation%2C%20crisp%20textile%20and%20leather%20texture%20details%20visible&width=600&height=600&seq=prod-dunk-v2&orientation=squarish',
    imageWidth: 600,
    imageHeight: 600,
    tag: 'Top',
  },
  {
    id: 'jordan-4',
    name: 'Air Jordan 4 Retro Military Black',
    brand: 'Jordan',
    image: 'https://readdy.ai/api/search-image?query=White%20and%20black%20Air%20Jordan%204%20Retro%20sneaker%20three%20quarter%20angle%20view%20on%20warm%20sand%20colored%20surface%2C%20soft%20studio%20lighting%20with%20gentle%20shadows%2C%20clean%20commercial%20product%20photography%2C%20iconic%20basketball%20sneaker%20silhouette%2C%20premium%20leather%20and%20mesh%20materials%20visible%2C%20lifestyle%20aesthetic%20with%20minimalist%20composition&width=600&height=600&seq=prod-jordan4-v2&orientation=squarish',
    imageWidth: 600,
    imageHeight: 600,
  },
  {
    id: 'essentials-hoodie',
    name: 'Fear of God Essentials Hoodie Cream',
    brand: 'Essentials',
    image: 'https://readdy.ai/api/search-image?query=Cream%20beige%20Fear%20of%20God%20Essentials%20hoodie%20folded%20neatly%20on%20light%20warm%20surface%2C%20flat%20lay%20style%2C%20soft%20diffused%20natural%20lighting%2C%20relaxed%20casual%20streetwear%20aesthetic%2C%20visible%20rubberized%20logo%20patch%20detail%2C%20minimal%20composition%20with%20clean%20edges%2C%20cozy%20textural%20fabric%20showing%20brushed%20fleece%20interior%20texture&width=600&height=600&seq=prod-hoodie-v2&orientation=squarish',
    imageWidth: 600,
    imageHeight: 600,
  },
  {
    id: 'yeezy-slide',
    name: 'Yeezy Slide Onyx Black',
    brand: 'Yeezy',
    image: 'https://readdy.ai/api/search-image?query=Matte%20black%20Yeezy%20Slide%20sandal%20top%20down%20view%20on%20warm%20light%20stone%20surface%2C%20minimalist%20product%20photography%20with%20soft%20overhead%20lighting%2C%20sleek%20modern%20footwear%20design%2C%20subtle%20shadow%20beneath%20giving%20depth%2C%20smooth%20EVA%20foam%20texture%20visible%2C%20contemporary%20fashion%20presentation%20with%20clean%20negative%20space%20composition&width=600&height=600&seq=prod-yeezy-v2&orientation=squarish',
    imageWidth: 600,
    imageHeight: 600,
  },
];